import { MessageMedium } from 'constants/messageMediums';
import { Node, NodeId, RestCampaign, SendNodeData, Workflow } from 'modules/workflows/types';
import { post } from 'services/api';
import { UPSERT_WORKFLOW_CAMPAIGN } from './WorkflowsAPI';

interface UpsertWorkflowCampaignArgs {
  workflowId: Workflow['id'];
  workflowType: Workflow['workflowType'];
  nodeId: NodeId;
  x: Node['x'];
  y: Node['y'];
  campaignId: RestCampaign['id'];
  templateId: RestCampaign['templateId'];
  messageMedium: MessageMedium;
  campaignMetadata: Partial<RestCampaign>;
  sendNodeClass?: SendNodeData['nodeClass'];
}

export const upsertWorkflowCampaign = (args: UpsertWorkflowCampaignArgs) => {
  const { nodeId, x, y, ...rest } = args;

  return post(UPSERT_WORKFLOW_CAMPAIGN, {
    ...rest,
    nodeId: parseInt(nodeId, 10),
    // @ts-ignore
    x: Math.round(parseInt(x, 10)),
    // @ts-ignore
    y: Math.round(parseInt(y, 10)),
  });
};
